<template>
    <div class="shops-container">
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <div slot="header" class="flex justify-between">
                        <span>{{ $t('shops.queryCondition') }}</span>
                    </div>
                    <el-form :inline="true" :model="queryParams" class="demo-form-inline text-left">
                        <el-form-item>
                            <el-input v-model.trim="queryParams.remark" :placeholder="$t('shops.shopIdPlaceholder')"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model.trim="queryParams.roomNumLike"
                                      :placeholder="$t('shops.shopNumberPlaceholder')"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="queryParams.state" :placeholder="$t('shops.statePlaceholder')" clearable
                                       style="width: 100%">
                                <el-option :label="$t('shops.rented')" value="2006"></el-option>
                                <el-option :label="$t('shops.sold')" value="2007"></el-option>
                                <el-option :label="$t('shops.idle')" value="2008"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handleQuery">{{ $t('common.search') }}</el-button>
                            <el-button @click="handleReset">{{ $t('common.reset') }}</el-button>
                            <el-button v-if="showTu" @click="handleTu">隐藏图</el-button>
                            <el-button v-else @click="handleTu">显示图</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 10px" v-if="showTu">
            <el-col :span="24">
                <el-row :gutter="10">
                    <el-col class="room-item" v-for="(room, index) in shopsData" :key="index"
                            :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                        <div class="room-card" :style="{ 'background-color': getBgColor(room) }">
                            <div class="room-number">{{ room.roomName }}</div>
                            <div class="room-state">{{ room.roomSubTypeName }}-{{ room.apartmentName }}</div>
                            <div class="room-owner">{{ room.ownerName }}</div>
                            <div class="room-owner">{{ room.stateName }}</div>
                            <div class="room-debt">
                                <span>面积</span>：{{ room.roomArea }}
                                <span>建面</span>：{{ room.builtUpArea }}
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="24">
                <el-card>
                    <div slot="header" class="flex justify-between">
                        <span>{{ $t('shops.shopInfo') }}</span>
                        <el-button v-if="hasPrivilege('502020082453087940')" type="primary" size="small"
                                   style="float: right"
                                   @click="openAddDialog">
                            {{ $t('shops.addShop') }}
                        </el-button>
                    </div>

                    <el-table :data="shopsData" border style="width: 100%" v-loading="loading">
<!--                        <el-table-column prop="roomId" :label="$t('shops.shopId')" align="center"/>-->
                        <el-table-column :label="$t('shops.shopNumber')" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.roomNum }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('shops.remark')" align="center" width="160">
                            <template slot-scope="scope">
                                {{ scope.row.remark }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="stateName" :label="$t('shops.state')" align="center"/>
                        <el-table-column :label="$t('shops.owner')" align="center">
                            <template slot-scope="scope">
                                <router-link v-if="scope.row.ownerName"
                                             :to="`/views/owner/ownerDetail?ownerId=${scope.row.ownerId}`"
                                             target="_blank">
                                    {{ scope.row.ownerName }}
                                </router-link>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="link" :label="$t('shops.contactNumber')" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.link || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('shops.builtUpArea')" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.builtUpArea }}{{ $t('shops.squareMeter') }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('shops.roomArea')" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.roomArea }}{{ $t('shops.squareMeter') }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="startTime" :label="$t('shops.startTime')" align="center"/>
                        <el-table-column prop="endTime" :label="$t('shops.endTime')" align="center"/>
                            <el-table-column prop="roomRent" :label="$t('shops.rent')" align="center"/>
                        <el-table-column prop="feeCoefficient" :label="$t('shops.feeCoefficient')" align="center"/>
                        <el-table-column v-for="(item, index) in listColumns" :key="index" :label="item" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.listValues[index] }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('shops.floor')" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.layer }}{{ $t('shops.layerUnit') }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('shops.operation')" align="center" fixed="right" width="260">
                            <template slot-scope="scope">
                                <div class="operation-btns">
                                    <el-button-group>
                                        <el-button size="mini" @click="openLoginRecordDialog(scope.row)">
                                            {{ $t('shops.agreeRecord') }}
                                        </el-button>
                                        <el-button v-if="hasPrivilege('502020082493857941') && scope.row.state === '2008'"
                                                   size="mini"
                                                   @click="openRentDialog(scope.row)">
                                            {{ $t('shops.rentAction') }}
                                        </el-button>
                                        <el-button v-if="hasPrivilege('502020082493857941') && scope.row.state === '2008'"
                                                   size="mini"
                                                   @click="openSellDialog(scope.row)">
                                            {{ $t('shops.sellAction') }}
                                        </el-button>
                                    </el-button-group>
                                    <el-button-group>
                                        <el-button v-if="hasPrivilege('502020082493857941') && scope.row.state !== '2008'"
                                                   size="mini"
                                                   @click="openUnbind(scope.row)">
                                            {{ $t('shops.unbind') }}
                                        </el-button>
                                        <el-button v-if="hasPrivilege('502020082493857941')" size="mini" type="primary"
                                                   @click="openEditDialog(scope.row)">
                                            {{ $t('shops.edit') }}
                                        </el-button>
                                        <el-button v-if="hasPrivilege('502020082417457942')" size="mini" type="danger"
                                                   @click="openDeleteDialog(scope.row)">
                                            {{ $t('shops.delete') }}
                                        </el-button>
                                    </el-button-group>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                   :current-page="pagination.current" :page-sizes="[10, 20, 30]"
                                   :page-size="pagination.size"
                                   layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
                                   style="margin-top: 20px">
                    </el-pagination>
                </el-card>
            </el-col>
        </el-row>

        <!-- 子组件 -->
        <add-shops ref="addDialog" @success="loadData"></add-shops>
        <bind-owner-shops ref="bindDialog" @success="loadData"></bind-owner-shops>
        <edit-shops ref="editDialog" @success="loadData"></edit-shops>
        <delete-room ref="deleteDialog" @handleRefreshRoom="loadData"></delete-room>
        <owner-user-login-record-dialog ref="loginRecordDialog"></owner-user-login-record-dialog>
    </div>
</template>

<script>
import {queryShops} from '@/api/room/shopsApi'
import AddShops from '@/components/room/addShops'
import BindOwnerShops from '@/components/room/bindOwnerShops'
import EditShops from '@/components/room/editShops'
import DeleteRoom from '@/components/room/deleteRoom'
import OwnerUserLoginRecordDialog from '@/components/room/ownerUserLoginRecordDialog'

export default {
    name: 'ShopsList',
    components: {
        AddShops,
        BindOwnerShops,
        EditShops,
        DeleteRoom,
        OwnerUserLoginRecordDialog
    },
    data() {
        return {
            loading: false,
            showTu: false,
            queryParams: {
                remark: '',
              roomNumLike: '',
                state: '',
                roomType: '2020602',
                page: 1,
                row: 10
            },
            shopsData: [],
            listColumns: [],
            pagination: {
                current: 1,
                size: 10,
                total: 0
            }
        }
    },
    created() {
        // 同步 pagination.size 和 queryParams.row
        this.pagination.size = this.queryParams.row
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            queryShops(this.queryParams)
                .then(res => {
                    this.shopsData = res.rooms
                    this.pagination.total = res.total
                    this.dealShopsAttr(res.rooms)
                })
                .catch(error => {
                    console.error(error)
                    this.$message.error(error.message || this.$t('common.requestError'))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        handleQuery() {
            this.queryParams.page = 1
            this.loadData()
        },
        handleReset() {
            this.queryParams = {
                remark: '',
              roomNumLike: '',
                state: '',
                roomType: '2020602',
                page: 1,
                row: 10
            }
            this.loadData()
        },
        handleSizeChange(size) {
            this.queryParams.row = size
            this.loadData()
        },
        handleCurrentChange(page) {
            this.queryParams.page = page
            this.loadData()
        },
        openAddDialog() {
            this.$refs.addDialog.open()
        },
        openLoginRecordDialog(row) {
            this.$refs.loginRecordDialog.open(row)
        },
        openRentDialog(row) {
            this.$refs.bindDialog.open(row, '2006')
        },
        openSellDialog(row) {
            this.$refs.bindDialog.open(row, '2007')
        },
        openEditDialog(row) {
            this.$refs.editDialog.open(row)
        },
        openDeleteDialog(row) {
            this.$refs.deleteDialog.open(row)
        },
        openUnbind(row) {
            this.$router.push(`/views/owner/deleteOwnerRoom?ownerId=${row.ownerId}`)
        },
        handleTu() {
            this.showTu = !this.showTu
        },
        dealShopsAttr(shopss) {
            // 处理商铺属性列
            // this.listColumns = ['Attr1', 'Attr2'] // 实际应从API获取
            shopss.forEach(shop => {
                shop.listValues = [] // 实际应从API获取
            })
        },
        getBgColor(room) {
            if (room.oweAmount > 0) {
                return "#DC3545"
            }
            if (!room.ownerName) {
                return "#1AB394"
            }
            if (room.state === '2001') {
                return '#1296db'
            }
            if (room.state === '2003') {
                return '#4C8CDE'
            }
            if (room.state === '2005') {
                return '#085DC9'
            }
            if (room.state === '2004') {
                return '#9DBFEA'
            }
            if (room.state === '2006') {
                return '#365A87'
            }
            if (room.state === '2007') {
                return '#1053A8'
            }
            if (room.state === '2008') {
                return '#4E79AF'
            }
            if (room.state === '2009') {
                return '#5B81B1'
            }
            return "#1296db"
        },
    }
}
</script>

<style lang="scss" scoped>
.shops-container {
    padding: 20px;
    height: 100%;

    .floor-title {
        font-size: 16px;
        font-weight: bold;
        padding: 10px 0;
    }

    .floor-row {
        margin-bottom: 20px;
    }

    .room-item {
        margin-bottom: 10px;
    }

    .room-card {
        color: #fff;
        border-radius: 5px;
        padding: 10px;
        cursor: pointer;
        transition: all 0.3s;
        height: 100%;

        &:hover {
            transform: translateY(-3px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .room-number {
            font-weight: bold;
            margin-bottom: 5px;
        }

        .room-state,
        .room-owner,
        .room-debt {
            margin-bottom: 3px;
            font-size: 12px;
        }
    }
}

.clearfix:after {
    content: "";
    display: table;
    clear: both;
}

.operation-btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}
</style>
